"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const use_debounce_1 = require("use-debounce");
const react_2 = require("@ag-grid-community/react");
const client_side_row_model_1 = require("@ag-grid-community/client-side-row-model");
const range_selection_1 = require("@ag-grid-enterprise/range-selection");
const clipboard_1 = require("@ag-grid-enterprise/clipboard");
require("@ag-grid-community/core/dist/styles/ag-grid.css");
require("@ag-grid-community/core/dist/styles/ag-theme-balham.css");
const api_1 = require("../../api");
const errorNotification_1 = require("../../errorNotification");
const utils_1 = require("../utils");
const GridColumnTypes_1 = __importDefault(require("../Common/GridColumnTypes"));
const AuthContext_1 = require("../../Auth/AuthContext");
const quickOrderedFilter_1 = require("../quickOrderedFilter");
const gridUtils_1 = require("../gridUtils");
const Button_1 = __importDefault(require("../../forms/Button"));
const gridLocale_de_1 = __importDefault(require("../gridLocale.de"));
const InventoryColumns_1 = require("./InventoryColumns");
const Modal_1 = __importDefault(require("../Modal"));
const handleError_1 = __importDefault(require("../../handleError"));
const formik_1 = require("formik");
const NumberInput_1 = __importDefault(require("../../forms/Fields/NumberInput"));
const HandScanner_1 = __importDefault(require("../HandScanner"));
var quickFilterParsedValue = [];
const InventoryGrid = () => {
    const [inventoryGridApi, setInventoryGridApi] = (0, react_1.useState)(null);
    const [, setGridColumnApi] = (0, react_1.useState)(null);
    const [rows] = (0, react_1.useState)([]);
    const [columns] = (0, react_1.useState)([]);
    const [quantityModalOpened, setQuantityModalOpened] = (0, react_1.useState)(false);
    const [current, setCurrent] = (0, react_1.useState)({ quantity: 0, surplus: 0 });
    const [isUserEditingGrid, setIsUserEditingGrid] = (0, react_1.useState)(false);
    const [remoteTransactionsQueue, setRemoteTransactionsQueue] = (0, react_1.useState)([]);
    const [quickFilterText, setQuickFilterText] = (0, react_1.useState)('');
    const [debouncedQuickFilterText] = (0, use_debounce_1.useDebounce)(quickFilterText, 300);
    const [catalogColumnKey, setCatalogColumnKey] = (0, react_1.useState)([]);
    const inventoryApi = new api_1.InventoryApi();
    const { user } = (0, AuthContext_1.useAuth)();
    const handleScanUpdate = (item) => {
        const rowNode = inventoryGridApi.getRowNode(item.plant_option_id);
        rowNode.setDataValue('quantity', item.quantity);
        rowNode.setDataValue('surplus', item.surplus);
    };
    const onSubmit = async (values, { setErrors, setSubmitting }) => {
        setSubmitting(true);
        try {
            if (current.plant_option_id) {
                const data = await inventoryApi.update(current.plant_option_id, values);
                handleScanUpdate(data);
                (0, errorNotification_1.notify)('success', 'Lagerbestand gespeichert!');
            }
        }
        catch (error) {
            setErrors(error.response.data.errors);
        }
        setSubmitting(false);
    };
    (0, react_1.useEffect)(() => {
        quickFilterParsedValue = debouncedQuickFilterText ? debouncedQuickFilterText.toString().toLowerCase().split(' ') : [];
        if (inventoryGridApi)
            inventoryGridApi.onFilterChanged();
    }, [debouncedQuickFilterText]);
    const gridModules = [
        range_selection_1.RangeSelectionModule,
        client_side_row_model_1.ClientSideRowModelModule,
        clipboard_1.ClipboardModule,
    ];
    function onGridReady(params) {
        setInventoryGridApi(params.api);
        setGridColumnApi(params.columnApi);
        const fetchData = async () => {
            params.api.showLoadingOverlay();
            try {
                const data = await inventoryApi.index();
                setCatalogColumnKey(data.catalogColumnKey);
                params.api.setColumnDefs((0, InventoryColumns_1.inventoryColumns)());
                params.api.setRowData(data.items);
            }
            catch (e) {
                if (e.response.status === 403) {
                    (0, errorNotification_1.notifyError)(e.response.data.message);
                }
                else {
                    (0, errorNotification_1.notifyError)(e.message);
                }
            }
            params.api.hideOverlay();
        };
        fetchData().then(() => { });
    }
    const defaultColDef = {
        flex: 1,
        minWidth: 75,
        filter: true,
        resizable: true,
        sortable: true,
        floatingFilter: true,
        enablePivot: false,
        enableValue: false,
        enableRowGroup: false,
        cellClass: 'default',
    };
    const cellValueChanged = async (event) => {
        const { data } = event;
        const { newValue = null, oldValue = null } = event;
        if (newValue === oldValue) {
            return;
        }
        const isEditable = event.column.isCellEditable(event.node);
        if (isEditable) {
            const column = event.column.getColId();
            const { id } = data;
            try {
                debouncedUpdate({ id, quantity: event.node.data['quantity'], surplus: event.node.data['surplus'] });
            }
            catch (e) {
                (0, errorNotification_1.notifyError)(e.message);
            }
        }
    };
    const updatePlants = async (updates, apiG) => {
        const { success, changes } = await inventoryApi.gridUpdate({ updates });
        const update = changes.map(change => {
            const rowNode = inventoryGridApi.getRowNode(change.id);
            const a = updates.find(o => o.id === change.id);
            for (const [column, value] of Object.entries(change)) {
                if (inventoryGridApi.getColumnDef(column) !== null) {
                    rowNode.setDataValue(column, value);
                }
            }
        });
    };
    const debouncedUpdate = (0, utils_1.debounceAgg)(updatePlants, 250);
    const resetInventory = async () => {
        if (confirm('Wollen Sie wirklich den Lagerbestand zurücksetzen?')) {
            try {
                const { success } = await inventoryApi.reset();
                if (success) {
                    location.reload();
                }
            }
            catch (error) {
            }
        }
    };
    const exportOrderInventory = () => {
        location.assign(`/api/export/inventory-order`);
    };
    const doesExternalFilterPass = (node) => {
        return (0, quickOrderedFilter_1.quickOrderedFilter)((node.data['botanisch_slugged'] || '').split("-"), quickFilterParsedValue);
    };
    const isExternalFilterPresent = () => {
        return quickFilterParsedValue.length > 0;
    };
    const gridOptions = {
        enableRangeSelection: true,
        getRowNodeId: (data) => {
            return data.id;
        },
        isExternalFilterPresent: isExternalFilterPresent,
        doesExternalFilterPass: doesExternalFilterPass,
        excelStyles: [
            {
                id: 'default',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'derived',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'header',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            }
        ],
        //workaround for scanner event, that was messing the sorting order of focused header cell
        onSortChanged(event) {
            event.api.refreshHeader();
        }
    };
    const resetFilters = () => {
        inventoryGridApi.setFilterModel(null);
        setQuickFilterText('');
        inventoryGridApi.onFilterChanged();
    };
    const cellEditingStarted = (e) => {
        setIsUserEditingGrid(true);
    };
    const cellEditingStopped = (e) => {
        setIsUserEditingGrid(false);
    };
    const onCancel = (handleReset) => {
        setQuantityModalOpened(false);
        handleReset();
    };
    const onHandScan = async (sScancode, quantity = 0, handleSubmit, handleFormReset) => {
        await handleSubmit();
        setQuantityModalOpened(false);
        try {
            const data = await inventoryApi
                .get(sScancode);
            setCurrent({ ...data });
            setQuantityModalOpened(true);
            handleFormReset();
        }
        catch (error) {
            setCurrent({ quantity: 0, surplus: 0 });
            setQuantityModalOpened(false);
            handleFormReset();
            (0, handleError_1.default)(error);
        }
    };
    const gridTable = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_2.AgGridReact
        // @ts-ignore
        , { 
            // @ts-ignore
            modules: gridModules, localeText: gridLocale_de_1.default, disableStaticMarkup: true, onGridReady: onGridReady, 
            // onFirstDataRendered={onFirstDataRendered}
            onCellKeyDown: gridUtils_1.onCellKeyDown, onCellEditingStarted: cellEditingStarted, onCellEditingStopped: cellEditingStopped, rowSelection: 'multiple', suppressCopyRowsToClipboard: true, enableRangeSelection: true, undoRedoCellEditing: true, enableCellChangeFlash: true, animateRows: true, enableFillHandle: true, fillHandleDirection: 'y', gridOptions: gridOptions, columnDefs: columns, defaultColDef: defaultColDef, columnTypes: GridColumnTypes_1.default, rowData: rows, getRowNodeId: (data) => data.id, onCellValueChanged: cellValueChanged, suppressLastEmptyLineOnPaste: true }));
    }, [rows, columns, inventoryGridApi]);
    return (react_1.default.createElement("div", { className: "ag-theme-balham flex flex-col w-full flex-1" },
        react_1.default.createElement("div", { className: 'mb-2 flex items-end space-x-4' },
            react_1.default.createElement("div", { className: 'max-w-lg' },
                react_1.default.createElement("input", { type: "text", id: "filter-text-box", className: 'form-input', placeholder: "Suche nach botanischen Namen...", value: quickFilterText, onChange: e => setQuickFilterText(e.target.value) })),
            react_1.default.createElement("div", { className: 'space-x-2 flex flex-1' },
                react_1.default.createElement(Button_1.default, { onClick: () => resetInventory() }, "Lagerbestand zur\u00FCcksetzen"),
                react_1.default.createElement(Button_1.default, { onClick: () => exportOrderInventory() }, "Excel-Export")),
            react_1.default.createElement("div", { className: 'space-x-1' },
                react_1.default.createElement(Button_1.default, { onClick: () => resetFilters(), size: 'sm', variant: 'white' }, "Filter zur\u00FCcksetzen"),
                react_1.default.createElement(Button_1.default, { onClick: () => inventoryGridApi.undoCellEditing(), size: 'sm', variant: 'white' }, "Undo"),
                react_1.default.createElement(Button_1.default, { onClick: () => inventoryGridApi.redoCellEditing(), size: 'sm', variant: 'white' }, "Redo"))),
        gridTable,
        react_1.default.createElement(formik_1.Formik, { initialValues: {
                quantity: current.quantity,
                surplus: current.surplus,
            }, onSubmit: onSubmit, enableReinitialize: true }, ({ isSubmitting, handleSubmit, handleReset }) => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(HandScanner_1.default, { handleOnScan: (code) => onHandScan(code, undefined, handleSubmit, handleReset) }),
            react_1.default.createElement(Modal_1.default, { isOpen: quantityModalOpened, onRequestClose: () => { setQuantityModalOpened(false); handleReset(); } },
                react_1.default.createElement(formik_1.Form, { className: "space-y-4 m-4" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("span", { className: 'font-bold' }, "Name: "),
                        current ? current.name : ''),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("span", { className: 'font-bold' }, "EAN: "),
                        current ? current.ean : ''),
                    react_1.default.createElement(NumberInput_1.default, { name: 'quantity', label: 'Lagermenge', min: 0 }),
                    react_1.default.createElement("div", { className: 'flex justify-between' },
                        react_1.default.createElement(Button_1.default, { type: "button", variant: 'secondary', onClick: () => onCancel(handleReset) }, "Abbrechen"),
                        react_1.default.createElement(Button_1.default, { type: "submit", disabled: isSubmitting, onClick: () => { handleSubmit(); setQuantityModalOpened(false); } }, "Speichern")))))))));
};
exports.default = InventoryGrid;
